class ViewChargeCodesModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope, $q) {
    "ngInject";

    this.name = 'ViewChargeCodesModal';
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$q = $q;

    // Get the charge codes, labor rate, and pop rate from the modal instance
    $scope.chargeCodes = $uibModalInstance.chargeCodes || [];
    $scope.laborRate = $uibModalInstance.laborRate || {};
    $scope.popRate = $uibModalInstance.popRate || {};
    $scope.loading = true;
    $scope.chargeCodeDetails = [];

    // Fetch full details for each charge code
    const self = this;
    if ($scope.chargeCodes.length > 0) {
      const promises = $scope.chargeCodes.map(function(chargeCode) {
        if (!chargeCode.id) {
          return $q.resolve(chargeCode); // Return original if no id
        }
        return $http.get($rootScope.apiHost + '/api/admin/chargecodes/' + chargeCode.id, {withCredentials: true})
          .then(function(response) {
            return response.data;
          })
          .catch(function(error) {
            console.error('Error fetching charge code details:', error);
            return chargeCode; // Return original if fetch fails
          });
      });

      $q.all(promises).then(function(details) {
        $scope.chargeCodeDetails = details;
        $scope.loading = false;
      });
    } else {
      $scope.loading = false;
    }

    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
  }
}

export default ViewChargeCodesModalController;




// WEBPACK FOOTER //
// ./client/common/modals/viewChargeCodesModal/viewChargeCodesModal.controller.js